/**
 * Every color in oVRcome
 */
const HIGHLIGHT_COLORS = [
  {
    name: "CarrotOrange",
    color: "#F18824",
  },
  {
    name: "SeaBuckthorn",
    color: "#F49A2F",
  },
];

const SKIN_COLORS = [
  {
    name: "Manhattan",
    color: "#F7C8A0",
  },
  {
    name: "Rajah",
    color: "#F9B47D",
  },
];

const BACKGROUND_COLORS = [
  {
    name: "Bizarre",
    color: "#EFE2DA",
  },
  {
    name: "DawnPink",
    color: "#F4EBE5",
  },
  {
    name: "Pot Pourri",
    color: "#F7EEE9",
  },
  {
    name: "VistaWhite",
    color: "#FAF5F2",
  },
  {
    name: "Fantasy",
    color: "#FCF8F6",
  },
  {
    name: "Bianca",
    color: "#FDF9F7",
  },
];

const HIGH_RISK_COLORS = [
  {
    name: "WellRead",
    color: "#A62944",
  },
  {
    name: "Hibiscus",
    color: "#BE3657",
  },
  {
    name: "Charm",
    color: "#D8869A",
  },
  {
    name: "BeautyBush",
    color: "#ECC3CD",
  },
  {
    name: "VanillaIce",
    color: "#F2D7DD",
  },
  {
    name: "Fantasy",
    color: "#F8EBEE",
  },
  {
    name: "Amour",
    color: "#FCF5F7",
  },
];

const MED_RISK_COLORS = [
  {
    name: "Tango",
    color: "#E96623",
  },
  {
    name: "Jaffa",
    color: "#F47D31",
  },
  {
    name: "HitPink",
    color: "#F9B183",
  },
  {
    name: "ApricotPeach",
    color: "#FCD8C1",
  },
  {
    name: "Bridesmaid",
    color: "#FEF2EA",
  },
  {
    name: "Provincial Pink",
    color: "#FEF9F5",
  },
];

const SUCCESS_COLORS = [
  {
    name: "Patina",
    color: "#679F9B",
  },
  {
    name: "Neptune",
    color: "#80B9B5",
  },
  {
    name: "JungleMist",
    color: "#B3D5D3",
  },
  {
    name: "Mystic",
    color: "#D9EAE9",
  },
  {
    name: "AquaHaze",
    color: "#F2F8F8",
  },
  {
    name: "Porcelain",
    color: "#F9FBFB",
  },
];

const TEXT_COLORS = [
  {
    name: "Matterhorn",
    color: "#49323E",
  },
  {
    name: "Eggplant",
    color: "#5B404E",
  },
  {
    name: "Empress",
    color: "#807078",
  },
  {
    name: "Venus",
    color: "#9C8C95",
  },
  {
    name: "Pale Slate",
    color: "#CEC6CA",
  },
  {
    name: "BonJour",
    color: "#E6E2E4",
  },
  {
    name: "BonJourLight",
    color: "#EFECED",
  },
  {
    name: "HintOfRed",
    color: "#F7F5F6",
  },
];

const PRIMARY_COLORS = [
  {
    name: "Tuscany",
    color: "#CD5B38",
  },
  {
    name: "Mojo",
    color: "#C84E44",
  },
  {
    name: "Crail",
    color: "#C23F50",
  },
  {
    name: "Hibiscus",
    color: "#BE3657",
  },
  {
    name: "NightShadz",
    color: "#AF3256",
  },
  {
    name: "Camelot",
    color: "#872651",
  },
  {
    name: "TawnyPort",
    color: "#74204F",
  },
];

const PRIMARY_COLORS_ALT = [
  {
    name: "Tuscany",
    color: "#CD5B38",
  },
  {
    name: "RawSienna",
    color: "#D26B4C",
  },
  {
    name: "Tumbleweed",
    color: "#E19D88",
  },
  {
    name: "BeautyBush",
    color: "#F0CEC3",
  },
  {
    name: "AlbescentWhite",
    color: "#F5DED7",
  },
  {
    name: "WhiteLinen",
    color: "#FAEFEB",
  },
  {
    name: "Linen",
    color: "#FDF7F5",
  },
];

const SECONDARY_COLORS = [
  {
    name: "Loulou",
    color: "#4A1138",
  },
  {
    name: "WineBerry",
    color: "#621B4D",
  },
  {
    name: "MountbattenPink",
    color: "#A17694",
  },
  {
    name: "Maverick",
    color: "#D0BBCA",
  },
  {
    name: "Lola",
    color: "#E7DDE4",
  },
  {
    name: "LolaLight",
    color: "#EFE8ED",
  },
  {
    name: "HintOfRed",
    color: "#F7F4F6",
  },
];

export {
  TEXT_COLORS,
  SUCCESS_COLORS,
  BACKGROUND_COLORS,
  SKIN_COLORS,
  MED_RISK_COLORS,
  HIGH_RISK_COLORS,
  HIGHLIGHT_COLORS,
  PRIMARY_COLORS,
  PRIMARY_COLORS_ALT,
  SECONDARY_COLORS,
};
